<div class="table-data dashboard-scorecard scorecard">
    <div class="action-table-header">
      <div class="container-fluid">
        <div class="row center-div">
          <div class="col-12 col-sm-12 col-md-12">           
            <div class="left-part">
              <div class="back-link">
                <a href="javascript:void(0)" routerLink="/dashboard">
                    <svg class="back" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                      <g id="btn_back" transform="translate(-315 -129)">
                        <rect id="Rectangle_18055" data-name="Rectangle 18055" width="24" height="24" transform="translate(315 129)" fill="none"/>
                        <path id="arrow_back_FILL0_wght300_GRAD0_opsz24" d="M11.1,19.1,4.65,12.625a.7.7,0,0,1-.212-.288.936.936,0,0,1,0-.675.7.7,0,0,1,.212-.287L11.1,4.9a.822.822,0,0,1,.525-.213.678.678,0,0,1,.525.213.765.765,0,0,1,.237.525.753.753,0,0,1-.212.55l-5.3,5.275H18.5a.741.741,0,0,1,.525.212.755.755,0,0,1,0,1.075.74.74,0,0,1-.525.213H6.875l5.3,5.3a.736.736,0,0,1,.212.512.691.691,0,0,1-.212.538.755.755,0,0,1-1.075,0Z" transform="translate(315.188 128.994)" fill="#9e9e9e"/>
                      </g>
                    </svg>
                </a>
              </div>
              <!-- <div class="new-group-block">
                <button data-toggle="modal"
                data-target="#new-appointment" class="btn commn-btn coming-soon-btn" type="button">
                    New Assignment <span class="plus-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                      <rect data-name="Rectangle 17995" width="20" height="20" fill="none" />
                      <path d="M10,15.625a.676.676,0,0,1-.667-.667V10.667H5.042a.667.667,0,0,1,0-1.334H9.333V5.042a.667.667,0,0,1,1.334,0V9.333h4.291a.667.667,0,0,1,0,1.334H10.667v4.291a.676.676,0,0,1-.667.667Z" transform="translate(0)" fill="#0068D8" />
                    </svg>
                  </span>
                  <h3 class="coming-soon-tooltip" >This feature is coming soon  <span (click)="openComingSoonModal()">See all upcoming features</span> 
                     <button data-toggle="modal" data-target="#coming-soon" type="button"></button> 
                  </h3>
                </button>
              </div> -->
              <div class="search-block">                  
                <input id="search" type="text" class="search-input" placeholder="Search" role="search" name="scoreCardSearch" [(ngModel)]="scorecardReqtParam.search" (keyup.enter)="getSelectedGroupList(null)">
                <span class="close-icon" (click)="clearSearch()" *ngIf="this.scorecardReqtParam.search">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><rect _ngcontent-wvn-c189="" width="20" height="20" rx="6" fill="none"></rect><g _ngcontent-wvn-c189="" transform="translate(4 4)"><rect _ngcontent-wvn-c189="" width="16" height="16" fill="none"></rect><path _ngcontent-wvn-c189="" d="M10,11.229,5.979,15.25a.789.789,0,0,1-.6.24.863.863,0,0,1-.6-.261.88.88,0,0,1,0-1.229l4-4L4.75,5.979a.8.8,0,0,1-.24-.614.875.875,0,0,1,.261-.615A.88.88,0,0,1,6,4.75l4,4.021L14.021,4.75A.869.869,0,0,1,15.25,5.979L11.229,10l4.021,4.021a.855.855,0,0,1,0,1.208.88.88,0,0,1-1.229,0Z" transform="translate(-0.005 0.005)" fill="#9e9e9e"></path></g></svg>
                </span>
                <button class="search-icon" (click)="getSelectedGroupList(null)"> </button>
              </div>
              <div class="table-selection-block">
                <div class="select-options">
                  <div class="select-block multi-bor-0 width-auto">
                    <ng-multiselect-dropdown name="statesSelected" [placeholder]="'State'"
                                             [settings]="dropdownSettingState" [data]="states" [(ngModel)]="selectedStates"
                                             (onSelect)="getSelectedGroupList(selectedCustomGroupId)" (onSelectAll)="getSelectedGroupList(selectedCustomGroupId)"
                                             (onDeSelect)="getSelectedGroupList(selectedCustomGroupId)" (onDeSelectAll)="getSelectedGroupList(selectedCustomGroupId)">
                    </ng-multiselect-dropdown>
                  </div>
                </div>
                <div class="select-options" [class.disabled]="LOAsList?.length == 0">
                  <div class="select-block multi-bor-0 width-auto" [class.disabled]="LOAsList?.length == 0">
                    <ng-multiselect-dropdown [disabled]="LOAsList?.length == 0" name="LOAsListSelected"
                                             [placeholder]="'LOAs'" [settings]="dropdownSettingLOA" [data]="LOAsList"
                                             [(ngModel)]="selectedLOAsList" (onSelect)="getSelectedGroupList(selectedCustomGroupId)"
                                             (onSelectAll)="getSelectedGroupList(selectedCustomGroupId)" (onDeSelect)="getSelectedGroupList(selectedCustomGroupId)"
                                             (onDeSelectAll)="getSelectedGroupList(selectedCustomGroupId)">
                    </ng-multiselect-dropdown>
                  </div>
                </div>
                <!-- <div class="select-options" >
                  <div class="select-block multi-bor-0 width-auto" >
                    <ng-select [searchable]="false" [clearable]="false" [(ngModel)]="selectedAssignedNonAssigned" (change)="searchAssignedNonAssigned($event)">
                      <ng-option value="Greaterthan0">Greater than 0</ng-option>
                      <ng-option value="All">All</ng-option>
                    </ng-select>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="overall-score-header display-flex">
      <div class="score-block">
        <span class="title after-dash">OVERALL SCORE</span>
        <span class="percentage-value" *ngIf="overallScore">{{overallScore?.toPrecision(2)=="100.00"?overallScore:overallScore?.toPrecision(2)| number : '1.2-2'}}% - COMPLETE</span>
      </div>
      <!-- <div class="pagination-block">
        <div class="right-part">
          <div class="pagination">
            <div class="pagination-number">
              <span class="num-range">{{range[0]}} - {{range[1]}}</span> of <span
                  class="total-num">{{overallCount}}</span>
            </div>
            <div class="pagination-action-btn">
              <a class="back" href="javascript:void(0)" (click)="back()" [class.disabled]="range[0] <= 1">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                  <g id="ic-arrow" transform="translate(0)">
                    <rect data-name="Rectangle 17998" width="20" height="20" transform="translate(0)"
                          fill="none" />
                    <path d="M10,12.458a.867.867,0,0,1-.323-.062.925.925,0,0,1-.3-.208L5.6,8.417a.782.782,0,0,1-.229-.625.891.891,0,0,1,.25-.6.823.823,0,0,1,.625-.261.863.863,0,0,1,.6.261L10,10.354l3.167-3.166a.81.81,0,0,1,.593-.25.849.849,0,0,1,.615.27.881.881,0,0,1,0,1.23l-3.75,3.75a.925.925,0,0,1-.3.208A.867.867,0,0,1,10,12.458Z"
                          transform="translate(0.308 20) rotate(-90)" fill="#9E9E9E" />
                  </g>
                </svg>
              </a>
              <a class="next" href="javascript:void(0)" (click)="next()" [class.disabled]="range[1] == overallCount">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                  <g transform="translate(0)">
                    <rect data-name="Rectangle 17998" width="20" height="20" transform="translate(0)"
                          fill="none" />
                    <path d="M10,12.458a.867.867,0,0,1-.323-.062.925.925,0,0,1-.3-.208L5.6,8.417a.782.782,0,0,1-.229-.625.891.891,0,0,1,.25-.6.823.823,0,0,1,.625-.261.863.863,0,0,1,.6.261L10,10.354l3.167-3.166a.81.81,0,0,1,.593-.25.849.849,0,0,1,.615.27.881.881,0,0,1,0,1.23l-3.75,3.75a.925.925,0,0,1-.3.208A.867.867,0,0,1,10,12.458Z"
                          transform="translate(0.308 20) rotate(-90)" fill="#9E9E9E" />
                  </g>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <div class="groupname-list-block display-flex">
      <div class="left-part">
        <div class="group-name group-name-list border-btm">
          <div class="title-group-name">
            <div class="custom-control">
              <div class="custom-control custom-checkbox">  
                  <!-- <input type="checkbox" class="custom-control-input" id="groupName" value="" name="">
                  <label class="custom-control-label" for="allChecked">Group Name</label> -->
                  <h3>Group Name <img class="sorting-icon-asc" (click)="onSortGroupClick($event)"
                src="assets/images/ic_ascending.svg" alt="" />
              </h3>
              </div>
            </div>
          </div>
          <ul class="group-name-list" light malihu-scrollbar [scrollbarOptions]="darkScrollbarOptions">
            <!-- <li class="title-group-name">
              <div class="custom-control">
                <div class="custom-control custom-checkbox">  
                    <h3>Group Name</h3>
                    <img class="sorting-icon-asc" (click)="onSortGroupClick($event)"
                  src="assets/images/ic_ascending.svg" alt="" />
                </div>
              </div>
            </li>-->
            <li class="group-name-items" *ngFor="let group of scorecardGrpList" (click)="getLocalSelectedGroupList(group.customGroupId)">     
              <div [ngClass]="{'completion-perc-sel': group.customGroupId == scorecardGrpDetail[0]?.customGroupId, 'completion-perc': group.customGroupId != scorecardGrpDetail[0]?.customGroupId}" 
              [ngStyle]="{'width': group.customGroupId != scorecardGrpDetail[0]?.customGroupId ? group.totalCompletion+'%' : '100%'}"></div>         
              <div class="custom-control">
                <div class="custom-control custom-checkbox"> 
                    <!-- <input type="checkbox" class="custom-control-input" id="{{group.customGroupId}}"> 
                    <label class="custom-control-label" for="{{group.customGroupId}}">{{group.customGroupName}}</label> -->
                    <label class="addlink max-width-tooltip-150" appEllipsifyMe>{{group.customGroupName}}</label>
                </div>
              </div>
              <span class="completion" [ngClass]="{'blue': group.totalCompletion >= 80, 'orange': group.totalCompletion > 20 && group.totalCompletion < 80, 'red': group.totalCompletion <= 20}">{{group.totalCompletion==100.00?group.totalCompletion:group.totalCompletion| number : '1.2-2'}}%</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="right-part">
        <div class="common-table">
          <div class="table-set-fixed">
            <table class="table edit-table">
              <thead>
                <tr>
                  <th scope="col">Group Name</th>
                  <th scope="col">Created By</th>
                  <th scope="col">Agents</th>
                  <th scope="col">Created Date</th>
                  <th scope="col">Locked</th>
                  <!-- <th scope="col"></th> -->
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of scorecardGrpDetail">
                  <td class="max-width-tooltip-200"> <div class="max-width-tooltip-200" appEllipsifyMe> <span class="active">{{item.customGroupName}}</span> </div></td>
                  <td><span class="set-max-content">{{item.createdBy}}</span></td>
                  <td><span class="set-max-content">{{totalAgents}}</span></td>
                  <td><span class="set-max-content">{{item.createdDate | date : 'MM-dd-yyyy hh:mm aa'}}</span></td>
                  <td><span class="set-max-content">{{item.isLocked == false ? 'No': 'Yes'}}</span></td>
                  <!-- <td>
                    <div class="action-edit-btn">                     
                      <a class="link edit" href="javascript:void();" data-toggle="modal" data-target="#new-group">
                        Edit
                        <span class="action-edit-icon">
                          <svg id="ic-edit-20px" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                            <rect id="Rectangle_17995" data-name="Rectangle 17995" width="20" height="20" fill="none" />
                            <path id="edit_FILL0_wght300_GRAD0_opsz20" d="M4.375,15.75h1.1L13,8.229l-1.083-1.1L4.375,14.667ZM15.812,7.312l-3-3.02.959-.938a1.333,1.333,0,0,1,1.9,0l1.1,1.1a1.357,1.357,0,0,1,.375.969,1.25,1.25,0,0,1-.4.948ZM3.833,17.083a.817.817,0,0,1-.791-.791V14.4a.775.775,0,0,1,.052-.281.753.753,0,0,1,.177-.261L11.9,5.229l3,3L6.271,16.854a.753.753,0,0,1-.261.177.775.775,0,0,1-.281.052Zm8.625-9.395-.541-.563L13,8.229Z" transform="translate(-0.094 -0.021)" fill="#0068d8" />
                          </svg>
                        </span>
                      </a>
                    </div>
                  </td> -->
                </tr>
              </tbody>
            </table>
          </div>
          <table class="table scorecard-list-table">
            <thead class="sticky-from-top">
              <tr>
                <th scope="col">Name <img class="sorting-icon-asc" (click)="onSortClick($event, 'displayName')"
                  src="assets/images/ic_ascending.svg" alt="" /></th>
                <th scope="col">Required/Missing Licenses</th>
                <th scope="col">Required/Missing LOA</th>
                <th scope="col">Completion <img class="sorting-icon-asc" (click)="onSortClick($event, 'completion')"
                  src="assets/images/ic_ascending.svg" alt="" /></th>
              </tr>
            </thead>
            <tbody>
              <tr class="addlink" *ngFor="let list of scorecardUserList" (click)="gotoDetailView(list)" [class.row-highlight]="selectedRecordId == list.userId">
                <td>{{list.displayName}}</td>
                <td>{{list.reqLicense}} - <strong>{{list.missingLicense}}</strong></td>
                <td>{{list.reqLOA}} - <strong>{{list.missingLOA}}</strong></td>
                <td><span class="completion" [ngClass]="{'blue': list.completion >= 80, 'orange': list.completion > 20 && list.completion < 80, 'red': list.completion <= 20}">{{list.completion==100.00?list.completion:list.completion| number : '1.2-2'}}%</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  
  

  
  <!-- Coming soon modal -->
  <app-coming-soon-modal [modalToggle]="openModal" (modalStatus)="modalStatus($event)"></app-coming-soon-modal>
  <!--  -->
